module.exports = __webpack_public_path__ + "img/table-icon-world-disabled.dec5ee72.png";